//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TeacherCalendarDisplayItem } from './TeacherCalendarDisplayItem';
import { EventCategoryNameDisplayItem } from './EventCategoryNameDisplayItem';
import { EventLocationNameDisplayItem } from './EventLocationNameDisplayItem';
import { StudentNameDisplayItem } from './StudentNameDisplayItem';

export class CalendarHoldDisplayItem extends ItemBase {
    OriginalEventID: string | null = null;
    TeacherID: string | null = null;
    Teacher: TeacherCalendarDisplayItem | null = null;
    StartDate: string = "1970-01-01T00:00:00";
    EndDate: string = "1970-01-01T00:00:00";
    ExpiryDate: string = "1970-01-01T00:00:00";
    OriginalEventDate: string = "1970-01-01T00:00:00";
    Duration: number = 0;
    Description: string | null = null;
    EventCategoryID: string | null = null;
    EventCategory: EventCategoryNameDisplayItem | null = null;
    EventLocationID: string | null = null;
    EventLocation: EventLocationNameDisplayItem | null = null;
    Attendees: StudentNameDisplayItem[] = [];

    constructor(initializer?: Partial<CalendarHoldDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CalendarHoldDisplayItem";
}
